import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { PackagingApiAdapter } from '../adapters/PackagingApiAdapter';
import { PackagingFilters } from '../models/Packaging';
import { PackagingService } from '../services/PackagingService';

// Hook con scroll infinito para listado de packaging
export const usePackaging = (filters: PackagingFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PackagingApiAdapter(httpClient);
  const packagingService = new PackagingService(apiAdapter);

  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isPending } =
    useInfiniteQuery({
      queryKey: ['packaging', filters],
      queryFn: ({ pageParam = 1 }) =>
        packagingService.getPackagingPaginated({
          ...filters,
          page: pageParam,
        }),
      getNextPageParam: (lastPage) => lastPage.nextPage,
      initialPageParam: 1,
      staleTime: 5 * 60 * 1000,
      enabled: filters.enabled !== false,
    });

  // Aplanar todas las páginas en un array único
  const items = data?.pages.flatMap((page) => page.items) ?? [];

  // Total del API (consistente en todas las páginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    items,
    isLoading: isLoading || isPending,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    totalPages: data?.pages.length ?? 0,
    totalItems: items.length,
    total: totalFromApi,
  };
};
